import styled from 'styled-components';

export const FormContainer = styled.form`
  min-width: 264px;
`;

export const Container = styled.div`
  padding-top: 12px;
  padding-right: 6px;
  padding-left: 12px;
`;

export const ActionsContainer = styled.div`
  padding-top: 12px;
  padding-right: 12px;
  padding-left: 12px;
`;

export const Footer = styled.div`
  padding: 16px 12px 12px;
  text-align: right;
`;
